import { render } from "./AddAnnoucement.vue?vue&type=template&id=f39a84c8&scoped=true"
import script from "./AddAnnoucement.vue?vue&type=script&lang=js"
export * from "./AddAnnoucement.vue?vue&type=script&lang=js"

import "./AddAnnoucement.vue?vue&type=style&index=0&id=f39a84c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39a84c8"]])

export default __exports__